// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app[data-v-7df76c59] .el-form-item__label {\n  text-align: right;\n}\n.lable-blue[data-v-7df76c59]  .el-form-item__label {\n  color: #1F75D5 !important;\n}\n", ""]);
// Exports
module.exports = exports;
